import { Box, Typography } from "@material-ui/core";
import React from "react";

const TypographiesComponent = () => {
  return (
    <Box style={{ display: "grid", gap: "1rem", padding: "0 40px" }}>
      <Typography variant="h1">
        This is a H1 Typography (1.5rem / 24px / 600 font-weight / 28px
        line-height / 0.5rem margin-bottom)
      </Typography>
      <Typography variant="h2">
        This is a H2 Typography (1.25rem / 20px / 500 font-weight / 24px
        line-height / 0.5rem margin-bottom)
      </Typography>
      <Typography variant="h3">
        This is a H3 Typography (1rem / 16px / 500 font-weight / 20px
        line-height)
      </Typography>
      <Typography variant="h4">
        This is a H4 Typography (0.875rem / 14px / 500 font-weight / 18px
        line-height)
      </Typography>
      <Typography variant="h5">
        This is a H5 Typography (0.75rem / 12px / 500 font-weight / 18px
        line-height)
      </Typography>
      <Typography variant="h6">
        This is a H6 Typography (0.625rem / 10px / 500 font-weight / 18px
        line-height)
      </Typography>
      <Typography variant="subtitle1">
        This is a Subtitle 1 Typography (1.5rem / 24px / 400 font-weight / 28px
        line-height)
      </Typography>
      <Typography variant="subtitle2">
        This is a Subtitle 2 Typography (1rem / 16px / 400 font-weight / 20px
        line-height)
      </Typography>
      <Typography variant="body1">
        This is a Body 1 Typography (0.875rem / 14px / 400 font-weight / 20px
        line-height)
      </Typography>
      <Typography variant="body2">
        This is a Body 2 Typography (0.75rem / 12px / 400 font-weight / 18px
        line-height)
      </Typography>
      <Typography variant="caption">
        This is a Caption Typography (0.625rem / 10px / 300 font-weight / 18px
        line-height)
      </Typography>
    </Box>
  );
};

export default TypographiesComponent;
